import { BRAND_COPY } from '@fyf/shared';

import { ScreenLayout } from '../components/ScreenLayout.js';
import { SubmitButton } from '../components/SubmitButton.js';
import { useCaptureDispatch } from '../context/CaptureFlowContext.js';

const { intro } = BRAND_COPY.screens;

export function IntroScreen() {
  const dispatch = useCaptureDispatch();

  function handleStart() {
    dispatch({ type: 'SET_SCREEN', payload: 'superpower' });
  }

  return (
    <ScreenLayout>
      <h1 className="text-[32px] font-['Lora',serif] text-center leading-tight mb-8">
        Every <span className="text-brand-gradient">Firestarter</span>
        <br />
        carries a flame.
      </h1>
      <p className="font-['DM_Sans',sans-serif] text-base text-white text-center mb-10">
        Three questions. One Spark. A flame
        <br />
        that&rsquo;s all your own.
      </p>

      <ol className="w-full max-w-md flex flex-col gap-4 mb-10">
        {intro.steps.map((step, i) => (
          <li key={i} className="flex items-start gap-4">
            <span
              className="shrink-0 w-9 h-9 rounded-full flex items-center justify-center font-['Lora',serif] text-base text-white"
              style={{
                backgroundImage:
                  'linear-gradient(-40.12deg, rgba(255, 255, 255, 0.2) 3.6%, rgba(255, 255, 255, 0.04) 96.4%)',
              }}
            >
              {i + 1}
            </span>
            <span className="font-['DM_Sans',sans-serif] text-base text-white pt-1.5">{step}</span>
          </li>
        ))}
      </ol>

      <div className="w-full max-w-md">
        <SubmitButton label={intro.button} onClick={handleStart} />
      </div>

      <img src="/aduro-logo-red.svg" alt="Aduro" className="mt-10 h-7 opacity-80" />
    </ScreenLayout>
  );
}
